module.exports = __webpack_public_path__ + "img/tree-3.03250703.png";